const data = {
  pageName: "OffersOTP",
  asset: {
    Dimension: "[Dimension:1480291611621(el_GR)]",
    "Dimension-parent": [
      {
        group: "Locale",
        parent: { id: 1490638990008, type: "ContentInstanceAsset" }
      }
    ],
    LinkMap: null,
    Publist: ["Vodafone"],
    Relationships: [],
    SegRating: [],
    Webreference: [
      {
        assetUrl: "ananeosi-kinitou2/",
        createdDate: "2019-08-09T11:54:11+0000",
        default: true,
        deviceGroup: "",
        href: "/ananeosi-kinitou2/",
        httpStatus: 200,
        modifiedDate: "2019-08-09T13:14:12+0000",
        params: "",
        patternid: 0,
        redirectUrl: "",
        redirectWebRoot: "",
        template: "Vodafone/RetentionLayout",
        webRoot: "Vodafone",
        wrapper: "pageWrapper"
      }
    ],
    actionAsset: null,
    actionAsset2: null,
    actionClass: null,
    actionClass2: null,
    actionTitle: null,
    actionTitle2: null,
    actionType: null,
    actionType2: null,
    actionURL: null,
    actionURL2: null,
    bannerBreadcrumb: [],
    body: null,
    bottomAssets: [],
    c2aAssets: [],
    callinglist: "r_cbu_retention_dcvm",
    click2callButtons: null,
    clicktocallid: "test",
    clicktocallphone: "2106703669",
    clicktocallversion: "new",
    clicktocallcalendar: "cbu",
    createdby: "fwadmin",
    createddate: "2019-08-09T11:49:23+0000",
    defaultImage: null,
    description: "",
    enddate: null,
    externaldoctype: "",
    filename: "",
    flexBackgroundImage: null,
    flextemplateid: { id: 1480291946753, type: "ContentDefinition" },
    formAction: null,
    formElAttributes: null,
    formId: "Retention_Consumer_LCM_Mobile",
    fw_uid: "fb976f85-6985-41dc-962d-9529a157504d",
    fwtags: [],
    id: 1490638990008,
    inputAssets: [],
    name: "Form - Retention Page",
    overviewImage: null,
    path: "",
    renderid: null,
    seoDescription: null,
    seoMetaRobots: null,
    seoOGDescription: null,
    seoOGImage: null,
    seoOGTitle: null,
    seoTitle: null,
    seoTwitterDescription: null,
    seoTwitterTitle: null,
    seoURLName: null,
    siteTitle: null,
    startdate: null,
    status: "ED",
    subTitle: null,
    subtype: "Forms",
    svgAsset: null,
    template: "/RetentionLayout",
    title: null,
    topAssets: [],
    topBanner: [],
    updatedby: "fwadmin",
    updateddate: "2019-08-09T13:14:12+0000",
    urlexternaldoc: {
      binaryStream: null,
      blobAddress: {
        columnName: "urlexternaldoc",
        identifier: 1490638990008,
        identifierColumnName: "id",
        tableName: "ContentInstanceAsset"
      },
      filename: null,
      foldername:
        "/u01/Oracle/Middleware/Oracle_Home/user_projects/domains/wcs_dev_domain/wcsites/wcsites/ccurl/",
      webReferences: []
    },
    urlexternaldocxml: {
      binaryStream: null,
      blobAddress: {
        columnName: "urlexternaldocxml",
        identifier: 1490638990008,
        identifierColumnName: "id",
        tableName: "ContentInstanceAsset"
      },
      filename: null,
      foldername:
        "/u01/Oracle/Middleware/Oracle_Home/user_projects/domains/wcs_dev_domain/wcsites/wcsites/ccurl/",
      webReferences: []
    }
  },
  services: {
    translations: {
      url: "OTP-old/translations",
      params: {}
    },
    createOTP: {
      url: "OTP/sendSms",
      params: {}
    },
    validateOTP: {
      url: "OTP/validateCode",
      params: {}
    },
    getHashedPhoneNumber: {
      url: "offers/offerWeb/getHashedPhoneNumber",
      params: {}
    },
    checkClickToCallRequest: {
      url: "clickToCall/checkClickToCallRequest",
      params: {}
    },
    checkClickToCallAvailability: {
      url: "clickToCall/checkClickToCallAvailability"
    }
  },
  externalLinks: {
    offerPage: "/prosfora-ananeosis/"
  }
};
exports.data = data;
